<template>
	<div>
        <div class="mt-4"><hr></div>
        <div class="band_detail">
            <div @click="openBand = !openBand" class="d-flex align-items-center justify-content-between">
                <h5 class="mb-0">Matching Band Details</h5>
                <SvgHeaderSvg :type="'down'" />
            </div>
            <div v-if="openBand" class="open_band_detail">
                <div>
                    <h4 class="mt-3">
                        <span @click="openDetail = true" :class="{'active': !openDetail}">Band Details</span>
                        <span v-if="currentCarat.num_lots != '0'" @click="openDetail = false" :class="{'active': openDetail}"> | Accent Details</span>
                    </h4>
                    <ul class="ps-0" v-show="openDetail">
                        <li><span class="text">Design Number</span> <span class="description"> {{ item.main_sku }}</span></li>
                        <li><span class="text">Setting Style</span> <span class="description"> {{ item.sub_type }}</span></li>
                        <li><span class="text">Metal Type</span> <span class="description"> {{ selected.label }}</span></li>
                        <!-- <li><span class="text">Average Width</span> <span class="description small_caps">{{ currentCarat.average_width }} </span></li> -->
                        <li class="">
                            <span class="text d-flex">
                                Average Width
                                <div class="tooltip_box">
                                    <SvgHeaderSvg class="ms-1" :type="'info'" />
                                    <div class="tooltip_text tooltip_text_mod">
                                        The shank thickness may vary as per the ring size.
                                    </div>
                                </div>
                            </span>
                            <span class="description small_case">{{currentCarat.average_width}}</span>
                        </li>
                        <li><span class="text" v-if="item.lab && item.lab != ''">Certificate</span> <span class="description"> {{ item.lab }}</span></li>
                       
                    </ul>
                    <ul class="ps-0" v-show="!openDetail && currentCarat.num_lots != '0'">
                       
                        <li><span class="text">Shape</span> <span class="description">  {{ selected.side_stone_shape }}</span></li>
                        <li><span class="text">Min. Total Carat </span> <span class="description small_caps"> {{ currentCarat.value }} ct. tw.</span></li>
                        <li><span class="text">Average Color</span> <span class="description"> {{ currentCarat.d_color }}</span></li>
                        <li><span class="text">Average Clarity</span> <span class="description"> {{ currentCarat.d_clarity }}</span></li>
                        <!-- <li><span class="text">Quantity</span> <span class="description small_caps"> {{ currentCarat.num_lots }} diamonds</span></li> -->
                        <li class="">
                                <span class="text d-flex">
                                    Quantity
                                    <div class="tooltip_box">
                                        <SvgHeaderSvg class="ms-1" :type="'info'" />
                                        <div class="tooltip_text tooltip_text_mod">
                                            The number of accent diamonds will vary as per the ring size.
                                        </div>
                                    </div>
                                </span>
                                <span class="description small_caps">{{currentCarat.num_lots}} diamonds </span>
                            </li>
                    </ul>
                </div>
               
            </div>
        </div>
        <div class="mt-4"><hr></div>
    </div>
</template>

<script setup>
    const props = defineProps(['selected', 'item'])
    const currentCarat = computed(()=> {
        return props.selected.carats[0]
    })

    const openDetail=ref(true)
    const openBand=ref(true)

</script>

<style scoped>
.small_caps{
    text-transform: lowercase;
}
.tooltip_text{
    text-transform: initial;
}
.band_detail{
    /* cursor: pointer; */
}
.band_detail h5 {
    font-size: 16px;
    font-weight: 600;
}

    
.open_band_detail h4 span{
    font-size: 14px;
    color: #000;
    cursor: pointer;
    text-transform: uppercase;
    font-weight: 600;
}
.open_band_detail h4 span.active{
    color: #9f9f9f;
}
.open_band_detail ul li{
    width: 100%;
    line-height: 2;
    padding-right: 10%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    list-style: none;
    font-size: 16px;
    text-transform: capitalize;
    font-weight: 500;
}
.open_band_detail ul li span.text {
    color: #6a6161;
    width: 50%;
}
.open_band_detail ul li span.description {
    color: #212529;
    width: 50%;
    font-weight: 400;
}

@media (max-width: 767px){
    .open_band_detail ul li{
        font-size: 14px;
        padding-right: 0;
    }
}
</style>
